// extracted by mini-css-extract-plugin
module.exports = {"main":"ColorSliderThumb_main__10nZ_"};